import { Link } from 'react-router-dom';
import { blogPosts, blogCategories, type BlogPost } from '@/mocks/blogPosts';

interface BlogCardProps {
  post: BlogPost;
}

function BlogCard({ post }: BlogCardProps) {
  return (
    <article className="group bg-white rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all duration-300 flex flex-col">
      <Link to={`/blog/${post.slug}`} className="block overflow-hidden">
        <div className="relative h-48 md:h-56 overflow-hidden">
          <img
            src={post.imageUrl}
            alt={post.imageAlt}
            className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/25 via-transparent to-transparent"></div>
          <div className="absolute top-3 left-3">
            <span className="bg-primary-500 text-background-50 text-xs font-medium px-2.5 py-1 rounded-full whitespace-nowrap">
              {post.category}
            </span>
          </div>
        </div>
      </Link>
      <div className="p-4 md:p-5 flex flex-col flex-1">
        <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3">
          <span>{post.date}</span>
          <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
          <span>{post.readTime}</span>
        </div>
        <Link to={`/blog/${post.slug}`} className="block mb-2">
          <h3 className="text-base md:text-lg font-bold text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors duration-200">
            {post.title}
          </h3>
        </Link>
        <p className="text-xs md:text-sm text-foreground-600 leading-relaxed flex-1">
          {post.excerpt}
        </p>
        <Link
          to={`/blog/${post.slug}`}
          className="inline-flex items-center gap-1.5 mt-4 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors duration-200 cursor-pointer whitespace-nowrap"
        >
          Read More
          <i className="ri-arrow-right-line text-sm"></i>
        </Link>
      </div>
    </article>
  );
}

export default BlogCard;